export default __webpack_public_path__ + "static-front/media/CollapseIcon.46fe2aab.svg";